// VDR custom scripts

// ---- Rotating search placeholder --------------------------------
(function () {
  // Edit these freely - the first one should match the theme's default placeholder
  var TEXTS = [
    'What are you selling today?',
    'Search Cisco switches, routers…',
    'Search IP phones & headsets…',
    'Search refurbished laptops & servers…'
  ];
  var ROTATE_EVERY = 3500; // ms each text stays on screen
  var FADE_MS = 300;       // must match the transition in custom.css

  var inputs = document.querySelectorAll('#search-in-modal-desktop, #search-in-modal-mobile');
  if (!inputs.length || TEXTS.length < 2) return;

  var i = 0;
  setInterval(function () {
    i = (i + 1) % TEXTS.length;
    inputs.forEach(function (input) {
      if (input.value !== '') return; // don't swap while the visitor is typing
      input.classList.add('placeholder-fading');
      setTimeout(function () {
        input.placeholder = TEXTS[i];
        input.classList.remove('placeholder-fading');
      }, FADE_MS);
    });
  }, ROTATE_EVERY);
})();


// ---- Page preloader removed 2026-06-24 (was a dark logo+spinner overlay) ----

/* ===== Coming Soon cards + Register Interest list/popup (migrated catalogue) ===== */
(function () {
  'use strict';

  var STORE_KEY = 'vdr_interest';
  var SUPPORT_EMAIL = 'info@voiceanddataresale.com';

  /* ---- Interest-list state (localStorage, all guarded) ---------------- */
  function get() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(list || [])); }
    catch (e) { /* storage unavailable / full - fail quietly */ }
  }
  function has(handle) {
    return get().some(function (it) { return it.handle === handle; });
  }
  function add(item) {
    if (!item || !item.handle) return get();
    var list = get();
    if (!list.some(function (it) { return it.handle === item.handle; })) {
      list.push({ handle: item.handle, title: item.title || '', url: item.url || '' });
      save(list);
    }
    return list;
  }
  function remove(handle) {
    var list = get().filter(function (it) { return it.handle !== handle; });
    save(list);
    return list;
  }
  function toggle(item) {
    if (!item || !item.handle) return get();
    return has(item.handle) ? remove(item.handle) : add(item);
  }
  function clear() { save([]); }

  /* ---- Sync the whole UI to the saved list --------------------------- */
  function syncAll() {
    syncBar();
    syncCards();
    syncModalList();
  }

  /* ---- Coming Soon cards: badge + Register Interest button ------------ */
  function initCS(root) {
    (root || document).querySelectorAll('.product-card__wrapper.is-coming-soon').forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      var handle = '';
      if (link) { var m = link.getAttribute('href').match(/\/products\/([a-z0-9-]+)/i); if (m) handle = m[1]; }
      var titleEl = card.querySelector('.product-card__title');
      var title = titleEl ? titleEl.textContent.trim() : '';
      var url = link ? link.getAttribute('href') : '';

      if (!card.__csDone) {
        card.__csDone = true;
        var imgWrap = card.querySelector('.product-card__image-container') || card;
        if (!card.querySelector('.cs-badge')) {
          var b = document.createElement('span'); b.className = 'cs-badge'; b.textContent = 'Coming Soon';
          imgWrap.appendChild(b);
        }
        if (!card.querySelector('.cs-register')) {
          var info = card.querySelector('.product-card__info') || card.querySelector('.product-card__info-wrapper') || card;
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cs-register';
          btn.setAttribute('data-handle', handle);
          btn.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            toggle({ handle: handle, title: title, url: url });
            var nowAdded = has(handle);
            syncAll();
            if (nowAdded) { showToast(); flyToBar(btn); } else hideToast();
          });
          info.appendChild(btn);
        }
      }
      // Always refresh the label/state (covers re-render + persistence)
      paintCardButton(card.querySelector('.cs-register'), handle);
    });
  }

  function paintCardButton(btn, handle) {
    if (!btn) return;
    if (has(handle)) {
      btn.classList.add('is-added');
      btn.setAttribute('aria-pressed', 'true');
      // write only on change: a rewrite is a DOM mutation, which would re-trigger the observer below
      if (!btn.querySelector('.cs-register__tick')) btn.innerHTML = 'Added <span class="cs-register__tick" aria-hidden="true">✓</span>';
    } else {
      btn.classList.remove('is-added');
      btn.setAttribute('aria-pressed', 'false');
      if (btn.textContent !== 'Register Interest') btn.textContent = 'Register Interest';
    }
  }

  function syncCards() {
    document.querySelectorAll('.product-card__wrapper.is-coming-soon .cs-register').forEach(function (btn) {
      paintCardButton(btn, btn.getAttribute('data-handle'));
    });
  }

  /* ---- Toast (single reused element) --------------------------------- */
  var toastEl, toastTimer;
  function buildToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'ri-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    var msg = document.createElement('span');
    msg.className = 'ri-toast__msg';
    msg.textContent = 'Added to your interest list';
    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'ri-toast__link';
    link.textContent = 'Register now';
    link.addEventListener('click', function () { hideToast(); openModal(); });
    toastEl.appendChild(msg);
    toastEl.appendChild(link);
    document.body.appendChild(toastEl);
    return toastEl;
  }
  function showToast() {
    buildToast();
    clearTimeout(toastTimer);
    // force reflow so the transition replays if shown again quickly
    toastEl.classList.remove('is-visible');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    toastTimer = setTimeout(hideToast, 3000);
  }
  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-visible');
    clearTimeout(toastTimer);
  }

  /* ---- Floating bar -------------------------------------------------- */
  var barEl, barCountEl;
  function buildBar() {
    if (barEl) return barEl;
    barEl = document.createElement('div');
    barEl.className = 'ri-bar';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ri-bar__btn';
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML = '<svg class="ri-bar__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 6h12M8 12h12M8 18h12"/><path d="M4 6h.01M4 12h.01M4 18h.01"/></svg>' +
      '<span class="ri-bar__count" aria-hidden="true">0</span>';
    btn.addEventListener('click', openModal);
    barCountEl = btn.querySelector('.ri-bar__count');
    barEl.appendChild(btn);
    document.body.appendChild(barEl);
    return barEl;
  }
  function syncBar() {
    buildBar();
    var n = get().length;
    // write only on change: rewriting the same number is still a DOM mutation, and the observer that
    // calls syncBar() would re-fire itself every ~120 ms forever (starving other debounced observers)
    if (barCountEl && barCountEl.textContent !== String(n)) barCountEl.textContent = String(n);
    var btn = barEl.querySelector('.ri-bar__btn');
    if (btn) btn.setAttribute('aria-label', 'Register interest (' + n + ' item' + (n === 1 ? '' : 's') + ')');
    barEl.classList.toggle('is-visible', n >= 1);
  }

  /* ---- Fly-to-list animation (doc icon arcs into the float button) ---- */
  function flyToBar(sourceEl) {
    try {
      if (!sourceEl || !barEl || typeof sourceEl.animate !== 'function') return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var barBtn = barEl.querySelector('.ri-bar__btn');
      if (!barBtn) return;
      var s = sourceEl.getBoundingClientRect();
      var t = barBtn.getBoundingClientRect();
      if (!s.width || !t.width) return;
      var size = 38;
      var fly = document.createElement('div');
      fly.className = 'ri-fly';
      fly.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M9 13h5M9 17h3"/></svg>';
      fly.style.left = (s.left + s.width / 2 - size / 2) + 'px';
      fly.style.top = (s.top + s.height / 2 - size / 2) + 'px';
      document.body.appendChild(fly);
      var dx = (t.left + t.width / 2) - (s.left + s.width / 2);
      var dy = (t.top + t.height / 2) - (s.top + s.height / 2);
      var anim = fly.animate([
        { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
        { transform: 'translate(' + (dx * 0.5) + 'px,' + (dy * 0.5 - 90) + 'px) scale(0.82) rotate(-14deg)', opacity: 0.96, offset: 0.5 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.18) rotate(4deg)', opacity: 0.2, offset: 1 }
      ], { duration: 680, easing: 'cubic-bezier(0.5, 0, 0.55, 1)' });
      var done = function () {
        if (fly.parentNode) fly.parentNode.removeChild(fly);
        barBtn.classList.remove('ri-bump'); void barBtn.offsetWidth; barBtn.classList.add('ri-bump');
        setTimeout(function () { barBtn.classList.remove('ri-bump'); }, 440);
      };
      if (anim && anim.finished && anim.finished.then) { anim.finished.then(done).catch(done); }
      else if (anim) { anim.onfinish = done; }
      else { setTimeout(done, 680); }
    } catch (e) {}
  }

  /* ---- Modal --------------------------------------------------------- */
  var modalEl, lastFocus;

  function formBodyHtml() {
    return '' +
      '<div class="ri-modal__header">' +
        '<h2 class="ri-modal__title" id="ri-modal-title">Register your interest</h2>' +
        '<button type="button" class="ri-modal__close" data-ri-close aria-label="Close">×</button>' +
      '</div>' +
      '<p class="ri-modal__intro">Tell us how to reach you and we will be in touch about the items below.</p>' +
      '<div class="ri-modal__cols">' +
      '<div class="ri-modal__items" aria-live="polite"></div>' +
      '<form class="ri-form" novalidate>' +
        '<div class="ri-field">' +
          '<label for="ri-name">Full name <span class="ri-req" aria-hidden="true">*</span></label>' +
          '<input id="ri-name" name="ri-name" type="text" autocomplete="name" required>' +
          '<span class="ri-error" data-for="ri-name"></span>' +
        '</div>' +
        '<div class="ri-field">' +
          '<label for="ri-email">Email <span class="ri-req" aria-hidden="true">*</span></label>' +
          '<input id="ri-email" name="ri-email" type="email" autocomplete="email" required>' +
          '<span class="ri-error" data-for="ri-email"></span>' +
        '</div>' +
        '<div class="ri-field">' +
          '<label for="ri-phone">Phone <span class="ri-optional">(optional)</span></label>' +
          '<input id="ri-phone" name="ri-phone" type="tel" autocomplete="tel">' +
        '</div>' +
        '<div class="ri-field">' +
          '<label for="ri-message">Message <span class="ri-optional">(optional)</span></label>' +
          '<textarea id="ri-message" name="ri-message" rows="3"></textarea>' +
        '</div>' +
        '<div class="ri-form__error" role="alert" hidden></div>' +
        '<button type="submit" class="ri-submit">' +
          '<span class="ri-submit__text">Register Interest</span>' +
          '<span class="ri-submit__dots" aria-hidden="true"><i></i><i></i><i></i></span>' +
        '</button>' +
      '</form>' +
      '</div>';
  }

  function bindFormHandlers() {
    var form = modalEl.querySelector('.ri-form');
    if (form) form.addEventListener('submit', onSubmit);
  }

  function buildModal() {
    if (modalEl) return modalEl;
    modalEl = document.createElement('div');
    modalEl.className = 'ri-modal';
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.innerHTML =
      '<div class="ri-modal__overlay" data-ri-close></div>' +
      '<div class="ri-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="ri-modal-title">' +
        '<div class="ri-modal__body">' + formBodyHtml() + '</div>' +
      '</div>';
    document.body.appendChild(modalEl);

    // Delegated handlers on the stable modal root - survive body re-render.
    modalEl.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-ri-close')) { closeModal(); return; }
      var rm = e.target.closest('[data-ri-remove]');
      if (rm) { remove(rm.getAttribute('data-ri-remove')); syncAll(); }
    });
    bindFormHandlers();
    return modalEl;
  }

  function resetModalBody() {
    var body = modalEl.querySelector('.ri-modal__body');
    if (!body) return;
    // Only rebuild if the form was replaced (e.g. after a success panel).
    if (!body.querySelector('.ri-form')) {
      body.innerHTML = formBodyHtml();
      bindFormHandlers();
    }
  }

  function syncModalList() {
    if (!modalEl) return;
    var wrap = modalEl.querySelector('.ri-modal__items');
    if (!wrap) return;
    var list = get();
    var submit = modalEl.querySelector('.ri-submit');
    if (!list.length) {
      wrap.innerHTML = '<p class="ri-empty">Your interest list is empty.</p>';
      if (submit) submit.disabled = true;
      return;
    }
    if (submit) submit.disabled = false;
    var html = '<ul class="ri-items">';
    list.forEach(function (it) {
      var t = escapeHtml(it.title || it.handle);
      html += '<li class="ri-items__row">' +
        '<span class="ri-items__title">' + t + '</span>' +
        '<button type="button" class="ri-items__remove" data-ri-remove="' + escapeHtml(it.handle) +
        '" aria-label="Remove ' + t + '">×</button>' +
        '</li>';
    });
    html += '</ul>';
    wrap.innerHTML = html;
  }

  function openModal() {
    buildModal();
    resetModalBody();
    syncModalList();
    lastFocus = document.activeElement;
    modalEl.classList.add('is-open');
    modalEl.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ri-modal-open');
    document.addEventListener('keydown', onKeydown);
    // focus first field once the open transition has begun
    var first = modalEl.querySelector('#ri-name');
    setTimeout(function () { if (first && !first.disabled) first.focus(); }, 60);
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ri-modal-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) { closeModal(); return; }
    if (e.key === 'Tab') trapFocus(e);
  }

  function trapFocus(e) {
    var focusables = modalEl.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---- Validation + submit ------------------------------------------- */
  function setFieldError(id, msg) {
    var el = modalEl.querySelector('.ri-error[data-for="' + id + '"]');
    var input = modalEl.querySelector('#' + id);
    if (el) el.textContent = msg || '';
    if (input) {
      input.classList.toggle('is-invalid', !!msg);
      if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    }
  }

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  function onSubmit(e) {
    e.preventDefault();
    var list = get();
    if (!list.length) return;

    var nameEl = modalEl.querySelector('#ri-name');
    var emailEl = modalEl.querySelector('#ri-email');
    var phoneEl = modalEl.querySelector('#ri-phone');
    var msgEl = modalEl.querySelector('#ri-message');
    var name = nameEl.value.trim();
    var email = emailEl.value.trim();
    var phone = phoneEl.value.trim();
    var message = msgEl.value.trim();

    var ok = true;
    if (!name) { setFieldError('ri-name', 'Please enter your name.'); ok = false; } else setFieldError('ri-name', '');
    if (!email) { setFieldError('ri-email', 'Please enter your email.'); ok = false; }
    else if (!validEmail(email)) { setFieldError('ri-email', 'Please enter a valid email address.'); ok = false; }
    else setFieldError('ri-email', '');
    if (!ok) {
      var firstBad = modalEl.querySelector('.is-invalid');
      if (firstBad) firstBad.focus();
      return;
    }

    var ref = makeRef();
    var formError = modalEl.querySelector('.ri-form__error');
    if (formError) { formError.hidden = true; formError.textContent = ''; }
    var submit = modalEl.querySelector('.ri-submit');
    if (submit) { submit.classList.add('is-loading'); submit.disabled = true; }

    submitContact({ name: name, email: email, phone: phone, message: message, ref: ref, items: list })
      .then(function (success) {
        if (success) {
          showSuccess(ref, list.length);
          clear();
          syncBar();
          syncCards();
        } else {
          throw new Error('submit-failed');
        }
      })
      .catch(function () {
        if (submit) { submit.classList.remove('is-loading'); submit.disabled = false; }
        if (formError) {
          formError.textContent = 'Something went wrong - please try again or email ' + SUPPORT_EMAIL;
          formError.hidden = false;
        }
      });
  }

  function makeRef() {
    var d = new Date();
    var ymd = '' + d.getFullYear() +
      ('0' + (d.getMonth() + 1)).slice(-2) +
      ('0' + d.getDate()).slice(-2);
    var rand = Math.random().toString(36).slice(2, 6).toUpperCase();
    while (rand.length < 4) rand += Math.random().toString(36).slice(2, 3).toUpperCase();
    return 'VDR-' + ymd + '-' + rand.slice(0, 4);
  }

  function submitContact(data) {
    var lines = [];
    lines.push('Register interest submission');
    lines.push('Reference: ' + data.ref);
    if (data.message) { lines.push(''); lines.push('Message:'); lines.push(data.message); }
    lines.push('');
    lines.push('Products of interest:');
    data.items.forEach(function (it) {
      var url = it.url ? (location.origin + it.url) : '';
      lines.push('- ' + (it.title || it.handle) + (url ? (' (' + url + ')') : ''));
    });
    var body = lines.join('\n');

    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[Name]', data.name || '');
    fd.append('contact[email]', data.email || '');
    fd.append('contact[Phone]', data.phone || '');
    fd.append('contact[Reference]', data.ref || '');
    fd.append('contact[Enquiry type]', 'Register interest');
    fd.append('contact[Body]', body);

    // Fast AJAX POST. Shopify processes + emails the contact form server-side
    // before responding, so any resolution counts as success. redirect:'manual'
    // makes the 302 (-> ?contact_posted=true) resolve as an opaqueredirect
    // instead of throwing on a cross-origin hop. Resolves in ~1-2s.
    return new Promise(function (resolve) {
      var settled = false;
      function done(ok) { if (settled) return; settled = true; resolve(ok); }
      fetch('/contact', { method: 'POST', body: fd, redirect: 'manual', headers: { 'Accept': 'text/html' } })
        .then(function () { done(true); })
        .catch(function () { done(false); });
      setTimeout(function () { done(true); }, 9000); // never hang
    });
  }

  function lottieSuccessUrl() {
    try {
      var sc = document.querySelector('script[src*="custom.js"]');
      if (sc && sc.src) return sc.src.replace(/custom\.js(\?[^?]*)?$/, 'vf2-success.json');
    } catch (e) {}
    return '';
  }
  function playSuccessLottie(container) {
    if (!container) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      container.innerHTML = '<span class="ri-success__tick" aria-hidden="true">✓</span>'; return;
    }
    var src = lottieSuccessUrl();
    if (!src) { container.innerHTML = '<span class="ri-success__tick" aria-hidden="true">✓</span>'; return; }
    function play() {
      if (window.lottie) { try { window.lottie.loadAnimation({ container: container, renderer: 'svg', loop: true, autoplay: true, path: src }); } catch (e) {} }
    }
    if (window.lottie) { play(); return; }
    var lib = document.getElementById('vf2-lottie-lib');
    if (lib) { lib.addEventListener('load', play); return; }
    var s = document.createElement('script');
    s.id = 'vf2-lottie-lib';
    s.src = 'https://cdn.jsdelivr.net/npm/lottie-web@5.12.2/build/player/lottie_light.min.js';
    s.onload = play;
    document.head.appendChild(s);
  }
  function showSuccess(ref, count) {
    var body = modalEl.querySelector('.ri-modal__body');
    if (!body) return;
    body.innerHTML =
      '<div class="ri-success">' +
        '<div class="ri-success__lottie" data-ri-lottie aria-hidden="true"></div>' +
        '<h2 class="ri-modal__title">Thank you</h2>' +
        '<p class="ri-success__line">We will be in touch about your ' + count + ' item' + (count === 1 ? '' : 's') + '.</p>' +
        '<p class="ri-success__ref">Your reference: <strong>' + escapeHtml(ref) + '</strong></p>' +
        '<button type="button" class="ri-submit ri-success__done" data-ri-close>Done</button>' +
      '</div>';
    playSuccessLottie(body.querySelector('[data-ri-lottie]'));
    var done = body.querySelector('.ri-success__done');
    if (done) setTimeout(function () { done.focus(); }, 40);
  }

  /* ---- Helpers ------------------------------------------------------- */
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---- Boot ---------------------------------------------------------- */
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () { initCS(); syncBar(); });
  document.addEventListener('shopify:section:load', function (e) { initCS(e.target); syncBar(); });

  /* PDP "Register interest" button (coming-soon product pages):
     add this product to the interest list, then open the modal to submit. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.vdr-pdp-register') : null;
    if (!btn) return;
    e.preventDefault();
    var item = {
      handle: btn.getAttribute('data-handle') || '',
      title: btn.getAttribute('data-title') || '',
      url: btn.getAttribute('data-url') || ''
    };
    if (item.handle && !has(item.handle)) { add(item); }
    syncAll();
    openModal();
  });
  if ('MutationObserver' in window) {
    var t; var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { initCS(); syncBar(); }, 120); });
    ready(function () { mo.observe(document.body, { childList: true, subtree: true }); });
  }
})();


/* ============================================================
   VDR Wishlist - localStorage store, hearts, count, page
   ============================================================ */
(function () {
  var KEY = 'vdr_wishlist_v1';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function idxOf(a, id) { for (var i = 0; i < a.length; i++) { if (String(a[i].id) === String(id)) return i; } return -1; }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} fire(); }
  function has(id) { return idxOf(read(), id) > -1; }
  function toggle(it) { var a = read(); var i = idxOf(a, it.id); if (i > -1) { a.splice(i, 1); } else { a.unshift(it); } write(a); return i < 0; }
  function remove(id) { var a = read(); var i = idxOf(a, id); if (i > -1) { a.splice(i, 1); write(a); } }
  function count() { return read().length; }
  function fire() {
    var detail = { count: count() };
    try { window.dispatchEvent(new CustomEvent('vdr:wishlist', { detail: detail })); }
    catch (e) { var ev = document.createEvent('CustomEvent'); ev.initCustomEvent('vdr:wishlist', false, false, detail); window.dispatchEvent(ev); }
  }
  window.VDRWishlist = { read: read, has: has, toggle: toggle, remove: remove, count: count };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function syncHearts() {
    var b = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < b.length; i++) {
      var on = has(b[i].getAttribute('data-wl-id'));
      b[i].classList.toggle('is-active', on);
      b[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      b[i].setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    }
  }
  function syncCount() {
    var c = count();
    var links = document.querySelectorAll('a[href*="/pages/wishlist"]');
    for (var i = 0; i < links.length; i++) {
      var badge = links[i].querySelector('.vdr-wl-count');
      if (!badge) { badge = document.createElement('span'); badge.className = 'vdr-wl-count'; links[i].appendChild(badge); }
      if (badge.textContent !== String(c)) badge.textContent = c; // write only on change (see syncBar)
      badge.style.display = c > 0 ? '' : 'none';
    }
  }
  function renderPage() {
    var root = document.querySelector('[data-vdr-wishlist-page]');
    if (!root) return;
    var grid = root.querySelector('[data-wl-grid]');
    var empty = root.querySelector('[data-wl-empty]');
    var items = read();
    if (grid) {
      grid.innerHTML = items.map(function (i) {
        return '<article class="wl-card" data-wl-card="' + esc(i.id) + '">' +
          '<a class="wl-card__media" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy">' : '') + '</a>' +
          '<div class="wl-card__body">' +
            '<a class="wl-card__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
            (i.price ? '<div class="wl-card__price">' + esc(i.price) + '</div>' : '') +
            '<div class="wl-card__actions">' +
              '<a class="wl-card__view" href="' + esc(i.url) + '">View product</a>' +
              '<button type="button" class="wl-card__remove" data-wl-remove="' + esc(i.id) + '" aria-label="Remove from wishlist">&times;</button>' +
            '</div>' +
          '</div>' +
        '</article>';
      }).join('');
    }
    if (empty) empty.hidden = items.length !== 0;
    var ct = root.querySelector('[data-wl-count-text]');
    if (ct) ct.textContent = items.length ? (items.length + (items.length === 1 ? ' product saved' : ' products saved')) : '';
  }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var btn = t.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      var it = {
        id: btn.getAttribute('data-wl-id'),
        handle: btn.getAttribute('data-wl-handle'),
        title: btn.getAttribute('data-wl-title'),
        url: btn.getAttribute('data-wl-url'),
        price: btn.getAttribute('data-wl-price'),
        image: btn.getAttribute('data-wl-image')
      };
      var added = toggle(it);
      btn.classList.toggle('is-active', added);
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');
      if (added) { btn.classList.remove('vdr-pop'); void btn.offsetWidth; btn.classList.add('vdr-pop'); }
      return;
    }
    var rb = t.closest('[data-wl-remove]');
    if (rb) { e.preventDefault(); remove(rb.getAttribute('data-wl-remove')); renderPage(); return; }
  }, false);

  window.addEventListener('vdr:wishlist', function () { syncHearts(); syncCount(); renderPage(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { syncHearts(); syncCount(); renderPage(); } });

  function initWL() { syncHearts(); syncCount(); renderPage(); }
  if (document.readyState !== 'loading') { initWL(); } else { document.addEventListener('DOMContentLoaded', initWL); }

  if ('MutationObserver' in window) {
    var to; var mo = new MutationObserver(function () { clearTimeout(to); to = setTimeout(function () { syncHearts(); syncCount(); }, 150); });
    function obs() { mo.observe(document.body, { childList: true, subtree: true }); }
    if (document.readyState !== 'loading') { obs(); } else { document.addEventListener('DOMContentLoaded', obs); }
  }
})();

/* Mobile click-to-call: floating phone FAB above the chat bubble + a
   "Call us" item in the mobile drawer menu (2026-06-29). The desktop
   header call card is hidden below lg, so mobile users get tap-to-dial. */
(function () {
  var CFG = window.VDR_CALL || {};
  var ENABLE = CFG.enable !== false;
  var NUMBER = (CFG.number || '+442084409908').toString();
  var TEL = 'tel:' + NUMBER.replace(/[^\d+]/g, '');
  var LABEL = (CFG.label || 'Call us: +44 (0)20 844 09908').toString();
  var ICON = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>';

  /* Floating mobile call button removed on request (2026-08-26). It sat above the
     Shopify Inbox chat launcher and duplicated the "Call us" item in the mobile
     drawer, which stays. This now only clears a FAB left over in a cached page
     rather than creating one. */
  function addFab() {
    var exf = document.querySelector('.vdr-call-fab');
    if (exf) exf.remove();
  }

  function addMenuItem() {
    if (!ENABLE) { var exl = document.querySelector('.vdr-call-li'); if (exl) exl.remove(); return true; }
    if (document.querySelector('.vdr-call-li')) return true;
    var links = document.querySelectorAll('.menu-link');
    var dl = null;
    for (var i = 0; i < links.length; i++) {
      if (links[i].closest('.mobile-menu-drawer') || links[i].closest('[class*=mobile-tabbed]') || links[i].closest('[id*=menu-level]')) { dl = links[i]; break; }
    }
    if (!dl) return false;
    var li = dl.closest('li');
    var ul = li ? li.parentElement : null;
    if (!ul) return false;
    var item = document.createElement('li');
    item.className = 'vdr-call-li';
    item.innerHTML = '<div class="menu-link flex items-center"><a href="' + TEL + '" class="flex-1 flex items-center cursor-pointer"><span class="vdr-call-ico">' + ICON + '</span><span class="x-break-words py-2"><span>' + LABEL + '</span></span></a></div>';
    ul.insertBefore(item, ul.firstChild);
    return true;
  }

  function init() {
    addFab();
    if (!addMenuItem()) {
      var tries = 0;
      var iv = setInterval(function () { tries++; if (addMenuItem() || tries > 24) clearInterval(iv); }, 250);
    }
  }

  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', function () { addFab(); addMenuItem(); });
})();

/* ============================================================================
   REVEAL FAIL-SAFE (2026-08-26)

   This theme hides content until a scroll-reveal observer adds .is-visible:
     .anm-fade-element  + [data-fade-on-intersect]   (theme sections)
     [data-rv]                                        (the custom v2 sections)

   Both observers fire on an intersection RATIO (e.g. threshold 0.08). An element
   taller than ~12x the viewport can never reach that ratio, so it stays at
   opacity 0 permanently - which is how a blog article rendered 16,000 characters
   of text completely invisible, and worst on mobile where the viewport is
   smallest. Tab panels hit the same wall: hidden at load, never intersect.

   This adds a second observer at threshold 0 (any pixel on screen counts) plus a
   short repeating sweep for late-injected content. Animations still play on
   scroll; the difference is that nothing can end up permanently blank.
   ========================================================================== */
(function () {
  var SEL = '[data-rv], .anm-fade-element, [data-fade-on-intersect]';
  var REVEAL = 'is-visible';

  function show(el) { if (!el.classList.contains(REVEAL)) el.classList.add(REVEAL); }

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.width > 0 && r.top < vh && r.bottom > 0;
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { show(entries[i].target); io.unobserve(entries[i].target); }
      }
    }, { threshold: 0 });
  }

  function scan() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.classList.contains(REVEAL)) continue;
      if (onScreen(el)) { show(el); continue; }
      if (io) { io.observe(el); } else { show(el); }
    }
  }

  function boot() {
    scan();
    var n = 0;
    var iv = setInterval(function () { scan(); if (++n > 12) clearInterval(iv); }, 400);
  }

  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  window.addEventListener('load', scan);
  window.addEventListener('resize', scan, { passive: true });
  document.addEventListener('shopify:section:load', scan);
})();

/* ============================================================
   Click-to-call tracking -> GA4 (G-EYBTQ49Y8T)
   Fires a `click_to_call` event whenever a visitor taps any
   tel: link, labelled by where the link lives so the header and
   the mobile hamburger can be compared separately.
   Note: this records the tap that opens the dialer. It cannot
   know whether the call was placed, connected or answered.
   ============================================================ */
(function () {
  var CALL_ENDPOINT = 'https://vdr-valuation-connector.cyb3rmedia.workers.dev/call';
  window.dataLayer = window.dataLayer || [];

  /* GA4 stores its client id in the _ga cookie as GA1.1.<id1>.<id2>.
     Carrying it onto the record lets a call be matched back to its GA4
     session later (which campaign, which landing page). */
  function gaClientId() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)_ga=GA\d\.\d\.(\d+\.\d+)/);
      return m ? m[1] : '';
    } catch (e) { return ''; }
  }

  function send() {
    // gtag() is just a dataLayer shim, so this is a safe fallback
    // if the Google tag has not finished booting yet.
    if (typeof window.gtag === 'function') { window.gtag.apply(window, arguments); }
    else { window.dataLayer.push(arguments); }
  }

  function locationOf(a) {
    if (a.closest('.vdrmsg')) return 'message_widget';
    if (a.closest('#menu-navigation, .main-menu-lv0, .vdr-call-li')) return 'mobile_menu';
    if (a.closest('.v2-phone') || a.classList.contains('v2-phone')) return 'header';
    if (a.closest('footer, [class*="footer"]')) return 'footer';
    if (a.closest('header, .x-header')) return 'header';
    return 'other';
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="tel:"]') : null;
    if (!a) return;
    var where = locationOf(a);
    var number = (a.getAttribute('href') || '').replace('tel:', '');

    // 1. GA4 (for trend reporting)
    try {
      send('event', 'click_to_call', {
        link_location: where,
        phone_number: number,
        page_path: window.location.pathname,
        is_touch: window.matchMedia('(pointer: coarse)').matches ? 'touch' : 'mouse'
      });
    } catch (err) { /* never block the call */ }

    // 2. VDR Calls record in the Shopify admin (for the actual lead list)
    try {
      var q = new URLSearchParams(window.location.search);
      var coarse = window.matchMedia('(pointer: coarse)').matches;
      var payload = JSON.stringify({
        phone_number: number,
        link_location: where,
        source_page: window.location.pathname + window.location.search,
        page_title: document.title,
        device: coarse ? (window.innerWidth >= 768 ? 'tablet' : 'mobile') : 'desktop',
        referrer: document.referrer || '',
        utm_source: q.get('utm_source') || '',
        utm_medium: q.get('utm_medium') || '',
        utm_campaign: q.get('utm_campaign') || '',
        ga_client_id: gaClientId()
      });
      // sendBeacon so the dialer opens instantly and the tap is never delayed.
      // Plain text keeps it a simple request (no CORS preflight); the Worker
      // parses the body as JSON regardless of content type.
      if (navigator.sendBeacon) { navigator.sendBeacon(CALL_ENDPOINT, payload); }
      else { fetch(CALL_ENDPOINT, { method: 'POST', body: payload, keepalive: true, mode: 'cors' }); }
    } catch (err) { /* logging must never break the call */ }
  }, true);
})();

/* ---- Product card titles: keep part numbers whole -------------------------
   CSS alone cannot stop a line breaking after a hyphen. word-break:keep-all
   only affects CJK, so "DCS-7050QX-32-R" still split across lines. Wrapping
   each hyphenated token in a nowrap span is the only reliable fix.

   Safety: if a token is genuinely wider than its column, the nowrap is removed
   from that title so it wraps rather than overflowing the card. */
(function () {
  var PART = /\S*-\S*/g;

  function protect(a) {
    if (a.dataset.vdrNb) return;
    // only touch plain-text titles, never markup we did not write
    if (a.childNodes.length !== 1 || a.firstChild.nodeType !== 3) return;
    var txt = a.textContent;
    if (txt.indexOf('-') === -1) { a.dataset.vdrNb = 'skip'; return; }
    a.innerHTML = txt.replace(/[&<>]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c];
    }).replace(PART, function (m) { return '<span class="vdr-nb">' + m + '</span>'; });
    a.dataset.vdrNb = '1';

    var box = a.closest('.product-card__title') || a.parentElement;
    if (box && a.scrollWidth > box.clientWidth + 1) {
      a.querySelectorAll('.vdr-nb').forEach(function (s) { s.classList.remove('vdr-nb'); });
      a.dataset.vdrNb = 'overflow';
    }
  }

  function run() {
    document.querySelectorAll('.product-card__title a').forEach(protect);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setTimeout(run, 800);

  /* cards can arrive later from filters, load-more or section re-render */
  var t;
  new MutationObserver(function () {
    clearTimeout(t); t = setTimeout(run, 150);
  }).observe(document.body, { childList: true, subtree: true });
})();
